// extracted by mini-css-extract-plugin
export default {"wrap":"Links_wrap__4YgxZ","btn":"Links_btn__XrUcU"};